export default {
  Regular: 'AvenirNext-Regular',
  MediumItalic: 'AvenirNext-MediumItalic',
  Medium: 'AvenirNext-Medium',
  DemiBold: 'AvenirNext-DemiBold',
  Bold: 'AvenirNext-Bold',
};
